import { FEEDBACK_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import feedbackTypes from '../../constants/feedbackTypes'
import { axios } from '../../services'

// 1 mark_resolved
const mark_resolved_feedback_request = () => {
  return {
    type: feedbackTypes.mark_resolved.request
  }
}

const mark_resolved_feedback_success = (response) => {
  return {
    type: feedbackTypes.mark_resolved.success,
    payload: response.data
  }
}

const mark_resolved_single_feedback_success = (response) => {
  return {
    type: feedbackTypes.mark_resolved.single,
    payload: response.data
  }
}

const mark_resolved_feedback_failure = (messages) => {
  return {
    type: feedbackTypes.mark_resolved.failure,
    payload: messages
  }
}

const mark_resolved_feedback = (feedback_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( mark_resolved_feedback_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.post(
      formatRoute(FEEDBACK_ROUTES.mark_resolved, {id: feedback_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The feedback status has changed to: Resolved.')
      if ( index ) {
        dispatch( mark_resolved_feedback_success(response) )

      } else {
        dispatch( mark_resolved_single_feedback_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error resolving feedback"]
      }
      dispatch( mark_resolved_feedback_failure( errors ) )
    })
  }
}

export {mark_resolved_feedback}



// WEBPACK FOOTER //
// ./src/js/actions/feedback/resolved.js